// ══════════════════════════════════════════════════════════════════════════════════════════════
//  EL BUSCA, A MANO EN TODA LA APP (B-875, 26-sep-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  El botón del Busca de la cabecera y el del menú de la foto (components/Layout) solo lanzan el evento
//  'biango-abrir-busca': el panel vive aquí, montado una vez en la app (App.jsx), así que la cabecera no carga nada más y
//  el Busca se abre igual desde cualquier pantalla.
import { useEffect, useState } from 'react'
import BuscaPanel from './BuscaPanel'

export const EVENTO_ABRIR_BUSCA = 'biango-abrir-busca'

export default function BuscaGlobal() {
  const [abierto, setAbierto] = useState(false)
  useEffect(() => {
    const abrir = () => setAbierto(true)
    window.addEventListener(EVENTO_ABRIR_BUSCA, abrir)
    return () => window.removeEventListener(EVENTO_ABRIR_BUSCA, abrir)
  }, [])
  if (!abierto) return null
  return <BuscaPanel onCerrar={() => setAbierto(false)} />
}
